export default "__VITE_ASSET__Dh2re1EI__"